<div class="row">
	<mat-card-header>
		<mat-card-title>
			Global Administrator
		</mat-card-title>
	</mat-card-header>

	<mat-card-content>
		<mat-card appearance="outlined">
			<mat-card-header>
				<mat-card-title>Search Criteria</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div class="row">
					<div class="col-9">

						<div class="row">
							<div class="col">
								<mat-form-field style="width: 100%">
									<mat-label [ngClass]="{'danger': msg.MSG?.length!>=1}">Search by</mat-label>
									<input [formControl]="searchTextCtrl" matInput (keydown.enter)="applyFilter($event)"
										placeholder="Username or Name or Email or Phone Number or Organization">
									<mat-icon matSuffix (click)="search(false)">search
									</mat-icon>
								</mat-form-field>
							</div>
						</div>


						<div class="row">
							<div class="col-4">
								<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="lstSelectedRegion"
									[reset]="resetField" [selectUserRegion]="true"
									(selectedRegionsChange)="disableButton = !this.validateSearchEnable()"
									[selectUserRegion]="false">
								</region-dropdown-two-way>
							</div>
							<div class="col-4">
								<district-dropdown-two-way [(selectedSchoolDistricts)]="lstSelecteddistrict"
									[reset]="resetField" [isMultiple]="true" [regions]="lstSelectedRegion"
									(selectedSchoolDistrictsChange)="disableButton = !this.validateSearchEnable()">
								</district-dropdown-two-way>
							</div>
							<div class="col-4">
								<roles-dropdown (eventEmitterRole)="roleEventEmitter($event)" [reset]="resetField">
								</roles-dropdown>
							</div>
						</div>
					</div>
				</div>
			</mat-card-content>
			<mat-card-actions>
				<div class="row">
					<div class="col-3">
						<button mat-raised-button color="primary" mat-button [disabled]="this.disableButton"
							(click)="search(false)">
							<mat-icon *ngIf="isLoadingResults">
								<mat-spinner diameter="18"> </mat-spinner>
							</mat-icon>
							Search
						</button>
					</div>
					<div class="col-3">
						<button mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>
					</div>
					<div class="col-6">
						<button *ngIf="isLoadingCount" (click)="search(true)" mat-raised-button color="primary"
							[matBadge]="this.totalSessionCount" matBadgePosition="before" matBadgeColor="accent">
							Session(s) active
						</button>
					</div>
				</div>
			</mat-card-actions>
		</mat-card>
	</mat-card-content>
</div>

<div class="row" style="margin-top: 15px;" class="margin-top-sm table-responsive">
	<mat-table *ngIf="this.lstUser.length>0" [dataSource]="dataSource" matSort
		(matSortChange)="announceSortChange($event)">
		<ng-container matColumnDef="ACTIONGLOBAL">
			<mat-header-cell *matHeaderCellDef style="padding-left: 0px;">
				<button mat-icon-button
					(click)="passwordResetStatus=!passwordResetStatus;showFilterData('ResetPassword')"
					[color]="(passwordResetStatus) ? 'primary': 'accent'" #tooltip="matTooltip"
					matTooltip="Toggle Pending Reset Password only" [matTooltipPosition]="position.value!"
					matTooltipHideDelay="10">
					<mat-icon>vpn_key</mat-icon>
				</button>
				<button mat-icon-button color="primary"
					(click)="currentSession=!currentSession;showFilterData('RemoveSession')"
					[color]="(currentSession) ? 'primary': 'accent'" #tooltip="matTooltip"
					matTooltip="Toggle Current Session Active only" [matTooltipPosition]="position.value!"
					matTooltipHideDelay="10">
					<mat-icon>remove_circle</mat-icon>
				</button>
				<button mat-icon-button color="primary"
					(click)="accountCreation=!accountCreation;showFilterData('CreateAccount')"
					[color]="(accountCreation) ? 'primary': 'accent'" #tooltip="matTooltip"
					matTooltip="Toggle Account Creation Active only" [matTooltipPosition]="position.value!"
					matTooltipHideDelay="10">
					<mat-icon>person</mat-icon>
				</button>
			</mat-header-cell>
			<mat-cell *matCellDef="let element" style="padding-left: 0px;">
				<div style="display:inline">
					<div class="row">
						<div class="col-2">
							<button mat-icon-button (click)="callActionAPI('ResetPassword',element)"
								[color]="element.LOGIN_DETAIL_PASSWORD_RECOVERIES?.length >0 ? 'primary': 'accent'"
								matTooltip="Reset Password">
								<mat-icon>vpn_key</mat-icon>
							</button>
						</div>
						<div class="col-2">
							<button mat-icon-button color="primary" (click)="callActionAPI('RemoveSession',element)"
								[color]="(element.LOGIN_DETAIL_SESSIONS?.length >0) ? 'primary': 'accent'"
								matTooltip="Remove Session">
								<mat-icon>remove_circle</mat-icon>
							</button>
						</div>
						<div class="col-2">
							<button mat-icon-button color="primary" (click)="callActionAPI('CreateAccount',element)"
								[color]="(element.LOGIN_DETAILS_CREATION?.length > 0) ? 'primary': 'accent'"
								matTooltip="Recreate Username/Password">
								<mat-icon>person</mat-icon>
							</button>
						</div>
						<div class="col-2">
							<button mat-icon-button color="primary" (click)="view(element)" matTooltip="View">
								<mat-icon>visibility</mat-icon>
							</button>
						</div>
						<div class="col-2">
							<button mat-icon-button color="primary" (click)="edit(element)" matTooltip="Edit">
								<mat-icon>edit</mat-icon>
							</button>
						</div>
					</div>
				</div>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="FIRSTNAME">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> First Name </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.PERSON.FIRST_NAME}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="LASTNAME">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> Last Name </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.PERSON.LAST_NAME}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="USERNAME">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> Username </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.USER_ID}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="EMAIL">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> Email </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element.EMAIL_ADDRESS}}

			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="REGION">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> Region </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element?.REGION.CODE}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="ORGANIZATION">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> Organization </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element?.WORKS_FOR?.NAME==null ? "" : element?.WORKS_FOR?.NAME}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="PHONENUMBER">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> Phone Number(s) </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{getElementData(element)}}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="ROLES">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> Role(s) </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<ol style="padding-left: 1.0em;">
					<div *ngFor="let r of element.USER_ROLES;let i=index;let last=last;">
						<li style="word-break: break-word;" *ngIf="i<3">
							{{r.ROLE.NAME}}
						</li>
						<div *ngIf="i>=3 && last">
							<div class="row">
								<div class="col">
									<!-- <mat-icon (click)="openDialogRoles(element.USER_ROLES)">list</mat-icon> -->
									<button mat-raised-button [matBadge]="i+1" matBadgePosition="below before"
										(click)="openDialogRoles(element.USER_ROLES)">
										<mat-icon>list</mat-icon>
									</button>
								</div>
							</div>
						</div>
					</div>
				</ol>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="SCHOOLDISTRICT">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> School Districts(s) </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<ol style="padding-left: 1.0em;">
					<div *ngFor="let d of element.SCHOOL_DISTRICTS;let i=index;let last=last;">
						<li style="word-break: break-word;" *ngIf="i<3">
							{{d.DISTRICTS}}
						</li>
						<div *ngIf="i>=3 && last">
							<div class="row">
								<div class="col">
									<button mat-raised-button [matBadge]="i+1" matBadgePosition="below before"
										(click)="openDialogSchoolDistrict(element.SCHOOL_DISTRICTS)">
										<mat-icon>list</mat-icon>
									</button>
								</div>
							</div>
						</div>
					</div>
				</ol>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="ACCOUNTSTATUS">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				<h3> Account Status </h3>
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{element?.LOGIN_DETAIL_STATUS ==null ? "" :
				element?.LOGIN_DETAIL_STATUS[0]?.LOGIN_DETAIL_STATUS_TYPES?.NAME}}
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
	</mat-table>
</div>
<div class="row">
	<mat-paginator #searchPaginator *ngIf="this.lstUser.length>0" [length]="dataSource.data.length"
		[pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
	</mat-paginator>

</div>